import { BaseZenputModel, Paginator } from '../../../backbone-unorganized/shared/forms';

export const ExportRecurringProjectLocationSubmissions = BaseZenputModel.extend({
    location_id: null,
    parent_project_id: null,
    filters: {
        recipient_email: null,
        date_start: null, // UTC and ISO format
        date_end: null // UTC and ISO format
    },

    url: function () {
        const paginator = new Paginator();

        const filters = this.get('filters');

        if (filters.recipient_email) {
            paginator.set('recipient_email', filters.recipient_email);
        }
        if (filters.date_start) {
            paginator.set('date_start', filters.date_start);
        }
        if (filters.date_end) {
            paginator.set('date_end', filters.date_end);
        }

        const query_params = paginator.get_query_string({ attrs: ['recipient_email', 'date_start', 'date_end'] });
        return `/api/v3/submissions/export/location/${this.get('location_id')}/project/${this.get(
            'parent_project_id'
        )}/?${query_params}`;
    }
});

export const CompletionRate = BaseZenputModel.extend({
    location_id: null,
    filters: {
        parent_project_id: null,
        date_start: null, // UTC and ISO format
        date_end: null // UTC and ISO format
    },

    defaults: {
        completion_rate: null
    },

    url: function () {
        const paginator = new Paginator();

        const filters = this.get('filters');

        if (filters.parent_project_id) {
            paginator.set('parent_project_id', filters.parent_project_id);
        }
        if (filters.date_start) {
            paginator.set('date_start', filters.date_start);
        }
        if (filters.date_end) {
            paginator.set('date_end', filters.date_end);
        }

        return `/api/v3/tasks/completion_rate/location/${this.get('location_id')}/?${paginator.get_query_string({
            attrs: ['parent_project_id', 'date_start', 'date_end']
        })}`;
    }
});
